import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-beige-light" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green-dark mb-6" data-id="element-178">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-dark/80 leading-relaxed bg-white p-6 rounded-2xl border border-dark-border/10" data-id="element-179">
            Domingo a las 11 de la noche. Mañana tienes clase de educación
            ambiental. Y todavía estás buscando cómo explicar la diferencia
            entre el efecto invernadero natural y el intensificado sin que tus
            alumnos se duerman o no entiendan nada.
            <br data-id="element-180" />
            <br data-id="element-181" />
            <span className="text-green-medium font-bold" data-id="element-182">
              No es tu culpa.
            </span>{' '}
            Es que llevas años peleando con materiales desorganizados, teoría
            densa copiada de manuales europeos y recursos pensados para otros
            contextos que después tienes que reescribir entero para adaptarlos a
            la realidad de tu país.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183">
          <h3 className="text-xl font-bold text-green-dark mb-8 text-center" data-id="element-184">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-185">
            {['Noches en vela buscando cómo traducir conceptos ambientales complejos a un lenguaje que tus alumnos de secundaria puedan entender', 'Clases improvisadas porque no encontraste un material claro con ejemplos de tu región y listo para usar a tiempo', 'Alumnos desconectados que sienten que la crisis ambiental no tiene nada que ver con ellos ni con su país', 'Silencios incómodos cuando un alumno pregunta cuánto le queda a los glaciares de los Andes o qué es el Acuerdo de Escazú y no tienes una respuesta clara a mano', 'Fines de semana perdidos armando actividades, evaluaciones y planificaciones desde cero una y otra vez'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl border border-red-900/10" data-id="element-186">
                <span className="text-red-500 mt-1" data-id="element-187">🔴</span>
                <span className="text-dark/80" data-id="element-188">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border/10" data-id="element-189">
            <p className="text-2xl font-serif font-bold text-green-dark" data-id="element-190">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tienes.
              Ahora te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-green-medium font-medium" data-id="element-191">
              Planifica todo tu año hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}